import { Storage } from '@ionic/storage';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router,NavigationExtras } from '@angular/router';
import { DataService } from '../data.service';
import { LoaderService } from '../loder_service/loader.service';

@Component({
  selector: 'app-productlist',
  templateUrl: './productlist.component.html',
  styleUrls: ['./productlist.component.scss'],
})
export class ProductlistComponent implements OnInit {
  category_id:any;
  pro_array:any;
  cart_count:any
  category_name: any;
  status: any;
  constructor(public storage:Storage, public restApi:DataService,public toastService:LoaderService, private route: ActivatedRoute, private router: Router,) { }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      console.log(JSON.parse(params.category_id))
      this.category_id=JSON.parse(params.category_id);
      this.status=JSON.parse(params.status);

    });
  }
ionViewWillEnter(){
 
    this.toastService.showLoader('')
    let postparams={
     catId:this.category_id,
     status: this.status,
     usersessionId:localStorage.getItem('user_id')
   }
   this.restApi.get_product(postparams).subscribe((data:any)=>{
     this.pro_array=data.pro_array;
     this.category_name= data.catName;
     if(this.pro_array.length==0){
       this.toastService.create('Product not found under this category')
     }
    this.toastService.hideLoader();
   },(error:any)=>{
     this.toastService.hideLoader();
     this.toastService.create('Having some issues from server end')
   })
 
 
    
    if(localStorage.getItem('cart_count')){
      this.cart_count=localStorage.getItem('cart_count');
    }else{
      
    }
  

}
goto_product_details(item){
  let product_id=item.product_id
  let navigationExtras: NavigationExtras = {
    queryParams: {
      product_id: JSON.stringify(product_id),
    }
  };
  console.log(item.product_id);
 
  this.router.navigate(['/productdetails'], navigationExtras); 
}
goto_sort_page(){
  
  let navigationExtras: NavigationExtras = {
    queryParams: {
      category_id: JSON.stringify(this.category_id),
    }
  };

  this.router.navigate(['/sort'], navigationExtras);
}

goto_filter_page(){
  
  let navigationExtras: NavigationExtras = {
    queryParams: {
      category_id: JSON.stringify(this.category_id),
    }
  };
 // console.log(item.product_id);
  //routerLink="/productdetails"
  //routerLink="/filter"
  this.router.navigate(['/filter'], navigationExtras);
}

}
